<script>
  import { companyName } from '$lib/utils/consts';

  import IndexSwipe from '$lib/components/index/swipe.svelte';
  import IndexAngle from '$lib/components/index/angle.svelte';
  import IndexReport from '$lib/components/index/report.svelte';
</script>

<svelte:head>
  <title>首页 - {companyName}</title>
</svelte:head>

<main>
  <!-- 轮播器 -->
  <IndexSwipe />

  <div class="ti-container">
    <IndexAngle />
    <IndexReport />
  </div>
</main>
